import React, { FC } from 'react';
import styled from '@emotion/styled';

type Props = {
  borderRadius?: number;
  className?: string;
  fill: string;
  color: string;
};

export const createSvgIcon =
  (Path: FC<Partial<Props>>, viewBox?: string) =>
  ({ className, fill, borderRadius, ...rest }: Props) =>
    (
      <SVG aria-hidden="true" className={className} fill={fill} viewBox={viewBox} {...rest}>
        <Path fill={fill} borderRadius={borderRadius} />
      </SVG>
    );

const SVG = styled.svg`
  width: 1em;
  height: 1em;
`;
